import Loadable from '../../components/loadable';

const StripePayers = Loadable({
  loader: () => import('../../pages/payers/stripe_payers'),
});

angular.module('gym').value('StripePayers', StripePayers);

const StripePayersFiltersModal = Loadable({
  loader: () => import('../../pages/payers/stripe_payers/stripe_payers_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('StripePayersFiltersModal', StripePayersFiltersModal);
